<template>
  <div>
    <div class="d-flex justify-content-between mb-3 pb-1">
      <DateRange :update="dateRange" :startDate="filter.startDate" :endDate="filter.endDate" />
      <div>
        <b-button variant="primary" size="sm" @click="exportPDF" class="export-btn">
          {{ 'PDF' | i18n }}
        </b-button>
      </div>
    </div>
    <Bar id="qwe" :chart-options="chartOptions" :chart-data="chartData" :height="height" />
  </div>
</template>

<script>
import axios from 'axios';
import { AuthMixin } from '../../../../mixins';
import api from '../../../api';
import DateRange from '../../common/date-range';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import moment from 'moment';

ChartJS.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale);

export default {
  title: 'Anlageninput graphisch',
  components: { DateRange, Bar },
  mixins: [AuthMixin],
  data() {
    return {
      chartId: 'line-chart',
      datasetIdKey: 'label',
      plantInput: api.plantInput,
      loadingInstance: null,
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
        startDate: moment().startOf('month').add(3, 'hour'),
        endDate: moment(),
      },
      data: [],
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Angelieferte Menge',
            data: [],
            backgroundColor: ['#2260ff', '#2260ff'],
            borderColor: ['#2260ff', '#2260ff'],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
      },
      height: 400,
    };
  },
  async mounted() {
    try {
      const l = this.$veLoading({
        target: document.querySelector('#loading-container'),
        name: 'wave',
      });
      this.setLoadingInstance(l);
      this.startLoading();
      const { startDate, endDate } = this.filter;
      const ctx = {};
      if (startDate) {
        ctx.startDate = moment(startDate).format('yyyy-MM-DD');
      }
      if (endDate) {
        ctx.endDate = moment(endDate).format('yyyy-MM-DD');
      }
      const response = await this.plantInput.getGraphData(ctx);

      this.stopLoading();
      this.filter.totalCount = response.totalCount;

      const dates = [
        ...this.generateDatesArray(startDate, endDate).map((el) => {
          return moment(el).format('DD.MM.yyyy');
        }),
      ];

      this.chartData.labels = [...dates.map((el) => moment(el, 'DD.MM.yyyy').format('DD.MM'))];

      const data = dates.map((el) => {
        const item = response.data.find((i) => moment(i.date).format('DD.MM.yyyy') === el);
        if (item) {
          return item.weight;
        }
        return 0;
      });

      // this.chartData.datasets[0].data = [...response.data.map((el) => el.weight)];
      this.chartData.datasets[0].data = [...data];
    } catch (error) {
      console.log('error', error);
    }
  },
  methods: {
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery, startDate, endDate } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (startDate) {
          ctx.startDate = moment(startDate).format('yyyy-MM-DD');
        }
        if (endDate) {
          ctx.endDate = moment(endDate).format('yyyy-MM-DD');
        }
        const response = await this.plantInput.getGraphData(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();

        const dates = [
          ...this.generateDatesArray(startDate, endDate).map((el) => {
            return moment(el).format('DD.MM.yyyy');
          }),
        ];

        this.chartData.labels = [...dates.map((el) => moment(el, 'DD.MM.yyyy').format('DD.MM'))];

        const data = dates.map((el) => {
          const item = response.data.find((i) => moment(i.date).format('DD.MM.yyyy') === el);
          if (item) {
            return item.weight;
          }
          return 0;
        });

        this.chartData.datasets[0].data = [...data];
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    dateRange(d) {
      this.filter.startDate = d.startDate;
      this.filter.endDate = d.endDate;
      this.getPage();
    },
    async exportPDF() {
      try {
        const { startDate, endDate } = this.filter;
        const ctx = {};
        if (startDate) {
          ctx.startDate = startDate;
        }
        if (endDate) {
          ctx.endDate = endDate;
        }

        const baseUrl = axios.defaults.baseURL;
        const auth = this.authStorageService.getAuth();
        const token = auth.access_token;
        fetch(`${baseUrl}/api/v1/gmva/plant-input/graphic/pdf?startDate=${startDate}&endDate=${endDate}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${moment().format('yyyy-MM-DD')}_Anlageninput_graphisch.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.showNotification({ type: 'success', message: this.$translate('file_has_been_downloaded_successful') });
          })
          .catch((err) => {
            console.log('error', err);
          });
      } catch (err) {
        console.log('err', err);
      }
    },
    generateDatesArray(start, end) {
      let arr = [];
      for (let dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
      }
      return arr;
    },
  },
};
</script>

<style lang="scss"></style>
